import React, { Component, Fragment } from 'react';

import { connect } from "react-redux";

import { IconButton } from "office-ui-fabric-react";
import { IRootState } from "../store";
import { licenseLevelIsAtLeast, SchoolWithAccessLevel } from "../models/School";
import DispatchProps from "../utils/DispatchProps";
import * as H from "history";
import { schoolAccessLevelIsAtLeast } from "../models/SchoolAccessRecord";
import { UserAccessLevel, userAccessLevelIsAtLeast } from '../models/UserAccessRecord';
import { AccountInfo } from '@azure/msal-browser';
import { AuthActions } from "../redux/reducers/Auth";
import * as _ from "lodash";


/* eslint import/no-webpack-loader-syntax: off */
import CDBLogoWhiteText from "!file-loader!../images/cdb_logo_white_text.svg";



import CDBNavLink, { CDBNavLinkDefinition, CDBSchoolNavLinkDefinition } from "./CDBNavLink";
import {Link} from "react-router-dom";

interface CDBNavProps {
    user?: AccountInfo,
    userIsCdbEmployee: boolean,
    usersCdbAccessLevel?: UserAccessLevel,
    userIsTenantManager: boolean,
    history: H.History,
    
    schoolsCanAccess?: SchoolWithAccessLevel[]; 
    
    tenantId?: string;
    schoolCode?: string;
    
    manageTenantId?: string
}

interface CDBNavState {
    allLinks: CDBNavLinkDefinition[];
    visibleLinks: CDBNavLinkDefinition[];
    overflowOpen: boolean;

    showLoading: boolean;
}

class CDBNav extends Component<CDBNavProps & DispatchProps, CDBNavState> {

    static displayName = CDBNav.name;

    constructor(props: CDBNavProps & DispatchProps) {
        super(props);

        this.state = {
            allLinks: [],
            visibleLinks: [],
            overflowOpen: false,
            showLoading: false
        };
    }

    async componentDidMount() {
        const links = this.calculateLinks();
        this.setState({
            allLinks: links
        });
    }

    async componentDidUpdate(prevProps: CDBNavProps, prevState: CDBNavState): Promise<void> {
        if (this.props.usersCdbAccessLevel !== prevProps.usersCdbAccessLevel ||
            this.props.userIsCdbEmployee !== prevProps.userIsCdbEmployee ||
            this.props.schoolsCanAccess !== prevProps.schoolsCanAccess ||
            this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode ||
            this.props.manageTenantId !== prevProps.manageTenantId ||
            this.props.userIsTenantManager !== prevProps.userIsTenantManager) {
            const links = this.calculateLinks();
            this.setState({
                allLinks: links
            });
        }

    }

    private calculateLinks() {
        let links: CDBNavLinkDefinition[];

        if (this.props.userIsCdbEmployee) {
            links = this.calculateCdbLinks();
        }
        else {
            if (this.props.manageTenantId && this.props.userIsTenantManager) {
                const manageTenantPath = `/manage-tenant/${this.props.manageTenantId}`;
                links = [
                    {
                        text: "Assignments",
                        path: `${manageTenantPath}/assignment-analytics`
                    }
                ];
            }
            else {
                links = this.calculateSchoolLinks();
            }
        }

        const signOut: CDBNavLinkDefinition = {
            text: "Sign out",
            path: "",
            onClick: () => { this.props.dispatch(AuthActions.signOut()) }
        };

        links.push(signOut);

        return links;
    }

    private calculateCdbLinks(): CDBNavLinkDefinition[] {
        if (!this.props.usersCdbAccessLevel) {
            this.setState({ showLoading: true });
            return [];
        }

        this.setState({ showLoading: false });
        const cdbLinks: CDBNavLinkDefinition[] = [];

        if (userAccessLevelIsAtLeast("Engineer", this.props.usersCdbAccessLevel)) {
            cdbLinks.splice(cdbLinks.length, 0,
                {
                    path: "/cdb-admin/schools",
                    text: "Schools",
                },
                {
                    path: "/cdb-admin/tenants",
                    text: "Tenants",
                },
                {
                    path: "/cdb-admin/workloads",
                    text: "Workloads",
                },
                {
                    path: "/cdb-admin/info",
                    text: "Info",
                },
                {
                    path: "/cdb-admin/user-access",
                    text: "CDB User Access",
                },
                {
                    path: "/cdb-admin/mailroom",
                    text: "Mailroom"
                },
                {
                    path: `/cdb-admin/rollover`,
                    text: "Rollovers",
                }
            );
        }
        
        if(userAccessLevelIsAtLeast("employee",this.props.usersCdbAccessLevel)) {
            cdbLinks.splice(cdbLinks.length,0,{
                path: "/cdb-admin/usage",
                text: "Usage"
            });
        }

        if (userAccessLevelIsAtLeast("admin", this.props.usersCdbAccessLevel)) {
            cdbLinks.splice(cdbLinks.length, 0, {
                path: "/dev/utils",
                text: "Dev Utils",
            });
        }

        return cdbLinks;
    }

    private calculateSchoolLinks(): CDBNavLinkDefinition[] {
        
        if (!this.props.tenantId || !this.props.schoolCode) {
            this.setState({ showLoading: true });
            return [];
        }
        
        if(this.props.schoolsCanAccess === undefined)
        {
            this.setState({ showLoading: true });
            return [];
        }

        this.setState({ showLoading: false });
        const managePath = `/manage/${this.props.tenantId}/${this.props.schoolCode}`
        const allSchoolLinks: CDBSchoolNavLinkDefinition[] = [
            {
                path: `${managePath}/cover-manager`,
                text: "Class Drop In",
                level: "leader",
                licenseAtLeast: "silver"
            },
            {
                path: `${managePath}/create-site`,
                text: "Sites",
                level: "manager",
                licenseAtLeast: "foundation"
            },
            {
                path: `${managePath}/assignment-menu`,
                text: "Assignments",
                level: "leader",
                licenseAtLeast: "silver"
            },
            {
                path: `${managePath}/school-data-menu`,
                text: "Data",
                level: "manager",
                licenseAtLeast: "silver"
            },
            {
                path: `${managePath}/school-access`,
                text: "Access",
                level: "manager",
                licenseAtLeast: "foundation"
            }
        ];
        
        const selectedSchoolWithAccessLevel = this.props.schoolsCanAccess.filter(sca => sca.school.tenantId === this.props.tenantId && sca.school.schoolCode == this.props.schoolCode)[0];

        return allSchoolLinks.filter(link =>
            schoolAccessLevelIsAtLeast(selectedSchoolWithAccessLevel?.level!, link.level) &&
            licenseLevelIsAtLeast(selectedSchoolWithAccessLevel?.school.license, link.licenseAtLeast));
    }

    private linkVisibilityChanged = (isVisible: boolean, linkDefinition: CDBNavLinkDefinition): void => {
        const newVisibleLinks = [...this.state.visibleLinks];
        if (isVisible) {
            newVisibleLinks.push(linkDefinition);
        }
        else {
            const index = newVisibleLinks.indexOf(linkDefinition);
            if (index !== -1) {
                newVisibleLinks.splice(index, 1);
            }
        }

        this.setState({
            visibleLinks: newVisibleLinks
        });
    }
    
    render() {
        if (!this.props.user) {
            return null;
        }

        let navLinks: any = [];
        if (this.props.user) {
            navLinks = this.state.allLinks.map((desiredLink) => {
                return <CDBNavLink key={`${this.props.tenantId}-${this.props.schoolCode}-${desiredLink.path}`} definition={desiredLink} onVisible={this.linkVisibilityChanged} />
            });
        }

        const nonVisibleLinks = _.difference(this.state.allLinks, this.state.visibleLinks);

        const contentStyleOverride = process.env.REACT_APP_NAV_BACKGROUND_OVERRIDE ? { background: process.env.REACT_APP_NAV_BACKGROUND_OVERRIDE } : {};
        
        
        let logoLink = "/";
        if(!this.props.userIsCdbEmployee)
        {
            if(this.props.manageTenantId !== undefined)
            {
                logoLink = `/manage-tenant/${this.props.manageTenantId}`
            }
            else
            {
                if(this.props.tenantId && this.props.schoolCode)
                {
                    logoLink = `/manage/${this.props.tenantId}/${this.props.schoolCode}`;
                }
            }
        }

        let loadingMessage = undefined;
        if (this.state.showLoading) {
            loadingMessage = <div className="cdb-admin-nav-message">
                <span className="flex-item">Loading...</span>
            </div>;
        }
        
        return (
            <Fragment>
                <div className={"cdb-admin-nav"} style={contentStyleOverride}>
                    <div className={"cdb-admin-content"}>
                        <div className="cdb-admin-nav__logo">
                            <Link to={logoLink}>
                                <img title={this.props.user?.username} src={CDBLogoWhiteText}/>
                            </Link>
                        </div>

                        <div className="cdb-admin-nav__links">
                            {loadingMessage}
                            {navLinks}
                        </div>

                        <div className="cdb-admin-nav__menu-button" style={{ display: nonVisibleLinks.length > 0 ? "flex" : "none" }}>
                            <IconButton iconProps={{ iconName: this.state.overflowOpen ? "Cancel" : "CollapseMenu" }} title="Menu" ariaLabel="Menu" onClick={() => {
                                this.setState({
                                    overflowOpen: !this.state.overflowOpen
                                })
                            }} />
                            <span>{this.state.overflowOpen ? "Close" : "Menu"}</span>
                        </div>

                    </div>
                </div>
                <div className={`cdb-admin-nav-overflow ${this.state.overflowOpen && nonVisibleLinks.length > 0 ? 'cdb-admin-nav-overflow--open' : ''}`} style={contentStyleOverride}>
                    {nonVisibleLinks.map((l: CDBNavLinkDefinition) => <CDBNavLink key={l.path} definition={l} onClick={() => this.setState({ overflowOpen: false })} />)}
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: {
        tenantId?: string, schoolCode?: string, manageTenantId?: string
    }): CDBNavProps => {
        return {
            history: state.history,
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            schoolsCanAccess: state.schools.schoolsCanAccess,
            manageTenantId: ownProps.manageTenantId,
            user: state.auth.user,
            userIsCdbEmployee: state.auth.userIsCdbEmployee,
            userIsTenantManager: state.schools.userIsTenantManager,
            usersCdbAccessLevel: state.auth.usersCdbAccessLevel,
        };
    }
)(CDBNav)